module.exports = __webpack_public_path__ + "static/img/item5.747948b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teacher/item5.png
// module id = Se9d
// module chunks = 63